import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  text-decoration: none !important;
  color: ${({ theme }) => theme.palette.auiblue} !important;
`;

export { StyledLink };
